export const ACQUISITION_KIOSK_MODE = 3;

export const DEFAULT_RETURN_PATH = '/acquisitions';
export const DEFAULT_SIGNATURE_PREFERENCE = 'print_signature';

const ACQUISITION_KIOSK_STORAGE_KEY = 'acquisitionKioskSession';
const ACQUISITION_KIOSK_BASE_PATH = '/acquisitions/kiosk';

export const buildAcquisitionCollectionId = (collectionBinaryId, collection) => {
	if (!collectionBinaryId || !collection) {
		return '';
	}

	return `${collectionBinaryId}-${collection}`;
};

export const getAcquisitionCollectionIdFromRow = (row) => {
	const collection = row?.collection ?? row?.pkey;
	const collectionBinaryId = row?.collection_binary_id ?? row?.binary_id;

	return buildAcquisitionCollectionId(collectionBinaryId, collection);
};

export const getAcquisitionKioskPath = (collectionId = '') => {
	return collectionId ? `${ACQUISITION_KIOSK_BASE_PATH}/${collectionId}` : ACQUISITION_KIOSK_BASE_PATH;
};

export const getAcquisitionFormsPath = (collectionId = '') => {
	return collectionId ? `/acquisitions/${collectionId}#forms` : DEFAULT_RETURN_PATH;
};

export const isAcquisitionKioskPathname = (pathname = '') => {
	return pathname === ACQUISITION_KIOSK_BASE_PATH || pathname.startsWith(`${ACQUISITION_KIOSK_BASE_PATH}/`);
};

export const getAcquisitionKioskSession = () => {
	if (typeof window === 'undefined') {
		return null;
	}

	try {
		const raw = window.sessionStorage.getItem(ACQUISITION_KIOSK_STORAGE_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch (error) {
		return null;
	}
};

export const setAcquisitionKioskSession = (session) => {
	if (typeof window === 'undefined') {
		return;
	}

	window.sessionStorage.setItem(ACQUISITION_KIOSK_STORAGE_KEY, JSON.stringify(session));
};

export const clearAcquisitionKioskSession = () => {
	if (typeof window === 'undefined') {
		return;
	}

	window.sessionStorage.removeItem(ACQUISITION_KIOSK_STORAGE_KEY);
};

export const getAcquisitionKioskLockedPath = () => {
	const session = getAcquisitionKioskSession();
	if (session?.lockedPath) {
		return session.lockedPath;
	}

	const collectionId = session?.collectionId ||
		session?.routeId ||
		buildAcquisitionCollectionId(session?.collection_binary_id, session?.collection);

	return getAcquisitionKioskPath(collectionId || '');
};

export const getAcquisitionRouteId = ({ collection, collection_binary_id } = {}) => {
	return buildAcquisitionCollectionId(collection_binary_id, collection);
};

export const buildAcquisitionKioskPath = getAcquisitionKioskPath;
export const buildAcquisitionFormsPath = getAcquisitionFormsPath;
export const readAcquisitionKioskSession = getAcquisitionKioskSession;
export const writeAcquisitionKioskSession = setAcquisitionKioskSession;
